import { Outlet } from 'react-router';

import { Navigate, useTypedParams } from '@sorare/routing';
import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { ANY_SPORT_MY_CARDS_COLLECTIONS_TYPE } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { isRarityStr } from '@sorare/core/src/lib/so5';

import type { PageParams } from './__generated__/routeParams.ts';

const GalleryRarityLayout = () => {
  const { rarity } = useTypedParams<PageParams>();
  const { generateSportContextPath } = useSportContext();

  if (!isRarityStr(rarity)) {
    return null;
  }
  if (rarity !== Rarity.common) {
    return (
      <Navigate
        to={generateSportContextPath(ANY_SPORT_MY_CARDS_COLLECTIONS_TYPE, {
          params: { type: rarity },
        })}
      />
    );
  }
  return <Outlet />;
};
export default GalleryRarityLayout;
